import createBasicModeHandlers from './basicMode';
import type { TCalculatorModeHandlerFactory } from '@src/types';

const createConverterModeHandlers: TCalculatorModeHandlerFactory = (actions) => {
  const baseHandlers = createBasicModeHandlers(actions);

  return {
    ...baseHandlers,
  };
};

export default createConverterModeHandlers;
